import { render, staticRenderFns } from "./nianbao.vue?vue&type=template&id=7e47659d&scoped=true&"
import script from "./nianbao.vue?vue&type=script&lang=js&"
export * from "./nianbao.vue?vue&type=script&lang=js&"
import style0 from "./nianbao.vue?vue&type=style&index=0&id=7e47659d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47659d",
  null
  
)

export default component.exports